import { render, staticRenderFns } from "./DomiciliationDashboard.vue?vue&type=template&id=b768409c&"
import script from "./DomiciliationDashboard.vue?vue&type=script&lang=js&"
export * from "./DomiciliationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports